import { render, staticRenderFns } from "./YelpIcon.vue?vue&type=template&id=48139c7a&functional=true&"
var script = {}
import style0 from "./YelpIcon.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\adviewer\\AdViewer.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48139c7a')) {
      api.createRecord('48139c7a', component.options)
    } else {
      api.rerender('48139c7a', component.options)
    }
    module.hot.accept("./YelpIcon.vue?vue&type=template&id=48139c7a&functional=true&", function () {
      api.rerender('48139c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "wwwroot/src/components/YelpIcon.vue"
export default component.exports